import {GisCrudService} from '../../core/services'

export class AppGisCrudService extends GisCrudService {}
